import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Control } from 'react-hook-form';
import jamespot from 'jamespot-user-api';
import { commonComponentsRegistry } from '../../registry/CommonRegistry';

const JRCInputAudience = commonComponentsRegistry.getLazyComponent('InputAudience');
const JRCMessage = commonComponentsRegistry.getLazyComponent('Message');
const JRCModal = commonComponentsRegistry.getLazyComponent('Modal');

export type ModalAudienceProps = {
    open: boolean;
    closeHandler: () => void;
    title?: string;
    control: Control<any>;
    warningMessage?: string;
    onSubmit: () => void;
    name?: string;
};

export const ModalAudience = ({
    open,
    closeHandler,
    title,
    control,
    warningMessage,
    onSubmit,
    name = 'publishTo',
}: ModalAudienceProps) => {
    const intl = useIntl();
    return (
        <JRCModal
            open={open}
            closeHandler={closeHandler}
            title={title ?? intl.formatMessage({ id: 'GLOBAL_Audience' })}
            buttons={[
                {
                    children: <FormattedMessage id="GLOBAL_Cancel" />,
                    color: 'cancel',
                    clickHandler: () => closeHandler(),
                },
                {
                    children: <FormattedMessage id="GLOBAL_Continue" />,
                    color: 'danger',
                    clickHandler: () => {
                        closeHandler();
                        onSubmit();
                    },
                },
            ]}>
            <JRCMessage
                variant={'warning'}
                message={warningMessage ?? intl.formatMessage({ id: 'FORM_Audience_Empty' })}
            />
            <JRCInputAudience
                asyncPromise={(inputValue: string) => jamespot.audience.autocomplete(inputValue)}
                searchable={true}
                control={control}
                multiple={true}
                placeholder={intl.formatMessage({ id: 'GLOBAL_Audience' })}
                name={name}
            />
        </JRCModal>
    );
};
